import { Link } from 'react-router-dom'

interface SectionHeaderProps {
  title: string
  subtitle?: string
  ctaText?: string
  ctaLink?: string
  centered?: boolean
}

export default function SectionHeader({
  title,
  subtitle,
  ctaText,
  ctaLink,
  centered = false,
}: SectionHeaderProps) {
  return (
    <div className={`mb-8 ${centered ? 'text-center' : 'flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4'}`}>
      <div>
        <h2 className="section-header text-2xl sm:text-3xl">
          {title}
        </h2>
        {subtitle && (
          <p className={`mt-2 text-archive-muted max-w-2xl ${centered ? 'mx-auto' : ''}`}>
            {subtitle}
          </p>
        )}
      </div>
      {ctaText && ctaLink && (
        <Link
          to={ctaLink}
          className="inline-flex items-center gap-2 text-sm font-medium text-archive-gold hover:text-archive-amber transition-colors group"
        >
          {ctaText}
          <svg
            className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </Link>
      )}
    </div>
  )
}
